//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'facebook'

let requiredPermissions = ['MANAGE', 'CREATE_CONTENT', 'MODERATE', 'ADVERTISE']

let state = {
  data : [],
  pages: []
}


//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async data ({ commit }, params) {
    try {
      commit('setData', [])
      let token = await getFacebookToken(params.account_id);
      if(!token)
        if(params.callback) params.callback({error: 'Facebook no configurado.'})

      Vue.request_facebook.get('me?fields=id,name,picture&access_token=' + token)
      .then( response => {
        if(response.data) {
          commit('setData', response.data)
          if(params.callback) params.callback(response.data)
        } else {
          if(params.callback)
            params.callback({error: `Error obteniendo datos de la página de ${resource}.`})
        }
      })
    } catch (e) {
      console.error(e)
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo datos de ${resource}.`})
    }
  },
  async pages ({ commit }, params) {
    try {
      console.log("PAGES ...", params.platform)
      commit('setPages', [])
      let next = true

      while (next) {
        try {
          let res = await Vue.request_facebook.get(`me/accounts`, {params: params.params || {}})
          if (res.data.data && Array.isArray(res.data.data)) {
            let pages = res.data.data.filter(p => {
              if (params.platform.indexOf('instagram')> -1) {
                console.log("YES INTAGRAM")
                return p.instagram_business_account && p.instagram_business_account.id
              } else {
                return true
              }
            }).map(p => {
              p.error = false
              p.isConnected = false
              console.log("INDEX OF ", params.platform.indexOf('instagram'))
              if (params.platform.indexOf('instagram')> -1) {
                p.instagram_business_account_id = p.instagram_business_account.id
              }
              return p
            }).filter(p => {
              console.log("tasks", p)
              if(!p.tasks) return false 
              for (let permission of requiredPermissions) {
                if(p.tasks.includes(permission)) return true
              }

              return false
            })

            let pagesFilter = await Vue.request.post(`${resource}/filterPages`, { pages: pages.map(p => p.id) })
            if (pagesFilter.data.success) {
              for (let page of pagesFilter.data.resource) {
                let found = pages.find(p => p.id == page.page_id)
                if (found) {
                  found.isConnected = page.isConnected
                  if(page.isConnected && params.platform.indexOf('instagram') < 0) {
                    found.other_accounts = page[`${params.platform}_accounts`]/*.filter(a => a.account_id != params.account_id)*/.map(a => {
                      let plat = a[`${params.platform.capitalize()}s`][0]
                      return {
                        platform: params.platform,
                        name: a.name,
                        account_id: a.account_id,
                        model_id: plat[`${params.platform}_id`],
                        page_id: plat.page_id
                      }
                    })
                  }
                }
              }
            }

            commit('concatPages', pages)
          }

          if (res.data.paging && res.data.paging.next) {
            params.params.after = res.data.paging.cursors.after
          } else {
            next = false
          }
        } catch (e) {
          console.error(e.message)
          next = false
        }
      }

      if (params.callback) params.callback()
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo páginas de Facebook.`})
      console.error(e)
    }
  },
  async instagramBusinessAccount ({ commit }, params) {
    try {
      let res = await Vue.request_facebook.get(`${params.page_id}`, params)
      if(res.data.instagram_business_account) {
        if(params.callback)
          params.callback(res.data.instagram_business_account)
      } else {
        if(params.callback)
          callback ({error: `La página no está asociada a una cuenta de Instagram para negocios.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo obteniendo perfil de Instagram para negocios.`})
      console.error(e)
    }
  },
  async get_messenger_profile ({ commit }, params) {
    try {
      //commit('setData', [])
      //let token = await getFacebookToken(params.account_id);
      let token = await getMessengerToken(params.model_id);
      if(!token)
        if(params.callback) params.callback({error: 'Facebook no configurado.'})

      Vue.request_facebook.get('me/messenger_profile?fields=get_started,persistent_menu,whitelisted_domains&access_token=' + token)
        .then( response => {
          //console.log(response.data)
          if(response.data) {
            //commit('setData', response.data)
            if(params.callback) params.callback({
              success: true,
              resource: parseMessengerProfile(response.data)
            })
          } else {
            if(params.callback)
              params.callback({error: `Error obteniendo el perfil de Messenger de ${resource}.`})
          }
        })
    } catch (e) {
      console.error(e)
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo datos de ${resource}.`})
    }
  },
  async set_messenger_profile ({ commit }, params) {
    try {
      //commit('setData', [])
      //let token = await getFacebookToken(params.account_id);
      let token = await getMessengerToken(params.model_id);
      if(!token)
        if(params.callback) params.callback({error: 'Facebook no configurado.'})

      var delete_array = [];
      if(!params.get_started) delete_array.push('get_started');
      if(!params.whitelisted_domains) delete_array.push('whitelisted_domains');
      if(!params.persistent_menu) delete_array.push('persistent_menu');
      if(delete_array.length) deleteMessengerProperties({fields: delete_array}, token);

      Vue.request_facebook.post('me/messenger_profile?access_token=' + token, params)
        .then( response => {
          if(response.data.result) {
            if(params.callback) params.callback({
              success: true,
            })
          } else {
            console.log('set messenger profile error:');
            console.log(response);
            if(params.callback)
              params.callback({error: `Error actualizando el perfil de Messenger de ${resource}.`})
          }
        })
    } catch (e) {
      console.error(e)
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando  el perfil de Messenger de ${resource}.`})
    }
  },
  async updateAccessToken ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${params.platform}/${params.model_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else {
        params.callback({error: `Error actualizando plataforma.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando plataforma.`})
      console.error(e)
    }
  },
  async filterPages ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/filterPages`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error filtrando páginas de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error filtrando páginas de ${resource_name}.`})
      console.error(e)
    }
  },
}

var getFacebookToken = (account_id) => {
  return Vue.request.get('account/' + account_id + '/platform/2/token')
    .then( response => {
    if(response.data.success){
      return response.data.resource.token
    } else {
      return null
    }
  }).catch( e => {
    console.log(e)
    return null
  })
}

var getMessengerToken = (model_id) => {
  return Vue.request.get('messenger/' + model_id)
    .then( response => {
      if(response.data.success){
        return response.data.resource.page_access_token
      } else {
        return null
      }
    }).catch( e => {
      console.log(e)
      return null
    })
}

var parseMessengerProfile = (body) => {
  let data = body.data;
  let response = {
    get_started: {
      next_block: null,
      flow_id: null
    },
    whitelisted_domains: [],
    persistent_menu: {
      locale: 'default',
      composer_input_disabled: false,
      call_to_actions: []
    }
  };

  if(!data || !data.length) return response;

  for(var i = 0; i < data.length; i++) {
    let data_item = body.data[i];
    for(let key in data_item) {
      switch (key) {
        case 'get_started':
          response.get_started = parsePayload(data_item[key].payload);
          break;
        case 'whitelisted_domains':
          response.whitelisted_domains = data_item[key].slice();
          break;
        case 'persistent_menu':
          if(data_item[key].length) {
            let menu = data_item[key][0];
            response.persistent_menu.locale = menu.locale;
            response.persistent_menu.composer_input_disabled = menu.composer_input_disabled;
            for(var menu_item of menu.call_to_actions) {
              if (menu_item.type == 'web_url') {
                response.persistent_menu.call_to_actions.push(menu_item)
              } else {
                let pl = parsePayload(menu_item.payload);
                response.persistent_menu.call_to_actions.push({
                  title: menu_item.title,
                  next_block: pl.next_block,
                  flow_id: pl.flow_id
                });
              }
            }
          }
          break;
      }
    }
  }

  return response;
};

var parsePayload = payload => {
  let res = {
    next_block: null,
    flow_id: null
  };

  try {
    let array = JSON.parse(payload);
    for(let item of array) {
      if(item.type == 'next_block') {
        res = {
          next_block: item.payload.next_block_id || null,
          flow_id: item.payload.flow_id || null
        }
      }
    }
  } catch (e) {
    console.log(e);
  }

  return res;
};

var deleteMessengerProperties = (params, token) => {
  Vue.request_facebook.delete('/me/messenger_profile?access_token=' + token, {data: params})
    .then( response => {
      console.log(response)
    }).catch( e => {
      console.log('Delete messenger profile error')
      console.log(e)
  })
};

//functions receive state
let mutations = {
  setData (state, items) {
    state.data = items
  },
  setPages (state, pages) {
    state.pages = pages
  },
  concatPages (state, pages) {
    state.pages = state.pages.concat(pages)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
